module.exports = __webpack_public_path__ + "img/standard-set.e625ef35.png";